let jQuery = window.jQuery = require('jquery')
let $ = jQuery
var Dialog = require('ei-dialog')
let PicStripe = require('@dankolz/pic-stripe')

const CircularStripe = require('@dankolz/circular-stripe')

require('./enable-parallax');
/**
 * Take strings like url('http://something/or/other') and return the
 * http://something/or/other
 */
function extractImageUrl(img) {
	if(!img) {
		return null
	}
	let r = /.*?\(['"]?(.*?)['"]?\).*/
	let match = r.exec(img)
	if(match) {
		return match[1]
	}
}

/**
 * URLs for the six pic boxes are generally the 1x density version. However,
 * for the lightbox we're going to want to show the 2x version if we're not
 * already. So transform what ever density the image name current is to
 * the 2x name.
 * @param {string} url 
 * @returns 
 */
function getDoubleSizeVersion(url) {
	if(!url) {
		return null
	}
	let r = /(.*?)(-half|-quarter|-2x)?\.(.{3,4})$/
	let match = r.exec(url)
	if(!match) {
		return null
	}
	return match[1] + '-2x.' + match[3]
}


$(function() {
	var diag
	let controler = PicStripe('.pic-stripe', {
		delay: 200000
	})

	let recipeFunctions = require("../../../../plugins/franklin-recipes/src/franklin-recipes")
	recipeFunctions($)
	
	
	/**
	 * Show a lightbox with an image at the url location. This lightbox will close on any
	 * click or keypress.
	 * @param {string} url 
	 */
	function openDialogForImage(url) {
		diag = new Dialog({
			title: '',
			dialogFrameClass: 'inspiration-detail-dialog',
			body: function () {
				return '<img class="full-image" src="' + url + '" />'
			}
			, buttons: [
			]
		})

		diag.open()
		let closeIt = function(evt) {
			evt.stopPropagation()
			diag.close()
			$('body').off('keyup', closeIt)
		}
		$('.inspiration-detail-dialog').on('click', closeIt)
		$('body').on('keyup', closeIt)
	}
	
	$('.recipe-tile').on('click', function(evt) {
		evt.preventDefault()
		let fullImage = $(this).attr('data-full-img')
		openDialogForImage(fullImage)
	})
	
	
	// If somebody clicks on one of the pic boxes open a lightbox with
	// the most detailed image possible
	let tiles = document.querySelectorAll('.six-pic-box > *')
	for(let tile of tiles) {
		tile.addEventListener('click', evt => {
			evt.preventDefault()
			let fullImage
			
			// See if there's an explict specification of the image we should use
			fullImage = tile.getAttribute('data-full-img')
			
			// If not, try to get the double size of the current background image
			if(!fullImage) {
				fullImage = window.getComputedStyle(tile).backgroundImage
				fullImage = extractImageUrl(fullImage)
				fullImage = getDoubleSizeVersion(fullImage)
			}
			if(fullImage) {
				openDialogForImage(fullImage)
			}
		})
	}


	$('.nutrition-panel-link a').on('click', function (evt) {
		evt.preventDefault()
		let upc = window.productUpc

		diag = new Dialog({
			title: 'Nutrition Facts Panel',
			dialogFrameClass: 'nutrition-facts-panel',
			body: function () {
				if(window.nutritionLabelImg) {
					return '<div id="nutrition-facts-panel-details"><img class="nutrition-label" alt="nutrition label" src="' + window.nutritionLabelImg + '" /></div>'
				}
				try {
					fetch('https://nutrition.hormelfoods.com/product-nutrition-fact-panel-html/00' + upc, {
						method: 'GET'
					}).then(function (response) {
						response.text().then(function (r) {
							$('#nutrition-facts-panel-details').html(r)
						})
					})
					.catch(function (err) {
						console.log(err)

						// $('#nutrition-facts-panel-details').html('<iframe border="0" id="nutrition-facts-frame" src="https://nutrition.hormelfoods.com/product-nutrition-fact-panel-iframe/00' + id + '"></iframe>')
						$('#nutrition-facts-panel-details').html($('.local-nutritional-content').html())
					})
					return '<div id="nutrition-facts-panel-details"></div>'
				}
				catch (e) {
					console.log(e)
					$('#nutrition-facts-panel-details').html('<iframe border="0" id="nutrition-facts-frame" src="https://nutrition.hormelfoods.com/product-nutrition-fact-panel-iframe/00' + id + '"></iframe>')

				}
			}
			, buttons: [
				{
					classes: 'btn btn-cancel',
					label: 'Close'
				}
			]
		})

		diag.open()
	})


	$('.open-recipe-filters').on('click', function() {
		$('.item-filter-list').toggleClass('open')
	})

	$('.close-recipe-filters').on('click', function() {
		$('.item-filter-list').toggleClass('open')
	})
	
	$('.tribar').on('click', function(evt) {
		$('body').toggleClass('menu-open')
	})
	
	let slider = document.querySelector('.all-products-in-category')
	if(slider) {
		let cs = new CircularStripe(slider)
		if(typeof window.currentStripeItem !== 'undefined') {
			cs.center(window.currentStripeItem)
		}
		else {
			cs.center()
		}
	}
	let btt = document.getElementById('back-to-top')
	if(btt) {
		btt.addEventListener('click', (evt) => {
			window.scrollTo(0, 0);
		})
	}
	
	/*
	 * Bug 100: Anchor to top of product title when clicking from the slider to
	 * a new product.
	 * 
	 * What's going on here is that the "scroll to top" element is interferring with
	 * the browser's ability to automatically scroll to the target. It's a bit of a
	 * hack, but what we're doing here is to detect whether there's a target in the
	 * url, and if so, try to find an element with that id, and if it exists,
	 * scroll it into view.
	 * 
	 * The delay seem necessary because the browser is still calculating where everything
	 * is on the page (which I suspect is the cause of the original problem.) Waiting
	 * a beat let's the page settle down enough so that the target has a definite
	 * position.
	 * 
	 * This is a general solution for a specific problem because other targets (if there
	 * are any) are likely broken in the same way.
	 */
	if(window.location.hash) {
		let target = document.getElementById(window.location.hash.substring(1))
		if(target) {
			setTimeout(function() {
				target.scrollIntoView()
			}, 200)
		}
	}

})
